import http from "@/utils/http";

// 分页查询机构老师
export function inqueryTeacher(data) {
  return http({
    url: "/user/teachers?name=" + data,
    method: "GET"
  });
}

// 查询班级老师
export function getClassTeacher(data) {
  return http({
    url: "/class/teachers?classid=" + data,
    method: "GET"
  });
}
